<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'account-info',
};
</script>

<style>
</style>
